import React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import DonationForm, { DonationVariablesBeforeSubmit } from '../components/DonationForm';

type Props = InjectedIntlProps;

class DonationCreate extends React.Component<Props> {
    private readonly initialData: DonationVariablesBeforeSubmit = {
        name: "",
        cms_url: "",
        active_from: "",
        active_to: "",
    };

    private onSubmit = (variables: DonationVariablesBeforeSubmit) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createDonation,
            variables: {
                ...variables,
                active: {
                    active_from: variables.active_from,
                    active_to: variables.active_to,
                },
            },
        });
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.donation.create.title' })}</h5>
                        </div>
                        <div className="ibox-content">
                            <DonationForm
                                formData={this.initialData}
                                onSubmit={this.onSubmit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
)(DonationCreate);



// WEBPACK FOOTER //
// ./src/modules/Donation/pages/DonationCreate.tsx